/* Image.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["image"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._njlp1rrk{contain:layout paint}";
const _8 = "._v564rca0{transition:background-color .3s}";
const _7 = "._bfhkh27k{background-color:var(--ds-skeleton)}";
const _6 = "._18m915vq{overflow-y:hidden}";
const _5 = "._1reo15vq{overflow-x:hidden}";
const _4 = "._2rko1sit{border-radius:var(--ds-border-radius,3px)}";
const _3 = "._19ith6cr{border:1px solid var(--ds-border,#dfe1e6)}";
import { N40 } from '@atlaskit/theme/colors';
import React, { useLayoutEffect, useRef } from 'react';
const _2 = "._v5641dkx{transition:opacity .4s}";
const _ = "._1bsb1osq{width:100%}";
export const Img = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _v5641dkx", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Img.displayName = 'Img';
}
export const ImageContainerDiv = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _3, _4, _5, _6, _7, _8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _19ith6cr _2rko1sit _1reo15vq _18m915vq _bfhkh27k _v564rca0 _njlp1rrk", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainerDiv.displayName = 'ImageContainerDiv';
}
const ImageContainer = props => {
  const {
      image
    } = props,
    otherImageProps = _objectWithoutProperties(props, _excluded3);
  const imageElementRef = useRef(null);
  const imageContainerRef = useRef(null);

  // We use direct DOM manipulation to bypass react's
  // re-rendering, that can cause a delay in image load
  useLayoutEffect(() => {
    // Prepare the image for fading-in. We do this in
    // `useLayoutEffect` which is executed only on the client side.
    // This means images are still visible if JS does not load for
    // some reason after a server side render
    if (imageElementRef.current && !imageElementRef.current.complete) {
      imageElementRef.current.style.opacity = 0;
    }
  }, []);
  const handleLoad = () => {
    if (imageElementRef.current) {
      imageElementRef.current.style.opacity = 1;
    }
    if (imageContainerRef.current) {
      imageContainerRef.current.style.backgroundColor = 'transparent';
    }
  };
  return /*#__PURE__*/React.createElement(ImageContainerDiv, {
    ref: imageContainerRef,
    style: {
      aspectRatio: "".concat(image.width, "/").concat(image.height),
      cursor: otherImageProps.onClick ? 'pointer' : 'auto'
    }
  }, /*#__PURE__*/React.createElement(Img, _extends({}, otherImageProps, {
    src: image.url,
    ref: imageElementRef,
    onLoad: handleLoad
  })));
};
export default ImageContainer;